import CreationDashboard from "@features/creation/components/CreationDashboard";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { LayoutDashboard } from "lucide-react";

export const Route = createFileRoute("/_app/creation/")({
  staticData: {
    title: "Création",
    icon: LayoutDashboard,
    tab_icon: LayoutDashboard,
    permission: PERMISSIONS.CREATION.ARTICLES.VIEW,
    section: "Creation",
    order: 26,
    description: "Module de création",
    module: "creation",
    showInTab: true,
    showInNav: false,
    showInBreadcrumb: true,
  },
  component: CreationDashboard,
});
